import * as CommonModels from './../commonModels';
import * as GarageModels from '../garage/garage';
import * as TyreModels from '../tyre/tyrePreview';
import * as OrderModels from '../order/order';

export class TyreStateListModel extends CommonModels.ResponseBase {
    Items: TyreStateModel[];
}

export class TyreStateModel {
  public TyreStateId: number;
  public HeightTread: number;
  public TryeStateValueId: number;
  public TryePosition: string;
  public IsRim: boolean;
  public DepositeId: number;
  public DepositeTakenDate: Date;
  public AddDate: Date;
  public UpdateDate: Date;
  public IsBlock: boolean;
  public IsTooShortHeightTread: boolean;
  public Dot: string;
  public AdditionalOptions: string;
  public Tyre: string;
  public TryePositionId: number;
  public DepositeTyreDiameter: number;
  public IsUnspecified: boolean;
    /// Informacja czy dana opona na danej pozycji istnieje. Jeżeli zostanie to przestaione na false na UI oznacza że daną oponę należy usunąć z bazy
  public IsValid: boolean;
    /// Informacja czy dana opona ma zostać zutylizowana
  public IsUtilized: boolean;
    /// Informacja czy dana opona ma zostać zwrocona - ma zostać utworzone zlecenie wydanian opony.
  public IsReturned: boolean;
  public Note: string;
  public Order: OrderModels.OrderPreviewModel;
}

export class TyreStatePreviewModel {
  public TyreStateId: number;
  public HeightTread: number;
  public TryeStateValueId: number;
  public TryeStateValue: string;
  public IsRim: boolean;
  public RimId: number;
  public Rim: string;
  public Dot: string;
  public TryePositionFullName: string;
  public TryePosition: string;
  public TryePositionId: number;
  public TryePositionIndex: number;
  public IsNew: boolean;
  public Note: string;
  public AddDate: Date;
  public DeleteDate: Date;
  public DepositeTakenDate: Date;
  public Code: string;
  public DepositeId: number;
  public TyreId: number;
  public DepositeTyreDiameter: number;
  public IsUnspecified: boolean;


  public Garage: GarageModels.GaragePreviewModel;

  public TyrePreview: TyreModels.TyrePreviewModel;

  public RimPreview: TyreModels.TyrePreviewModel;

  public Order: OrderModels.OrderPreviewModel;

  //Informacja czy dana opona ma brać udział w tworzeniu nowego zlecenia. Typ zlecenia jest przekazywany albo w requescie nowego zlecenia albo przez kontekst wywołania.
  public IsNewOrderCreate: boolean;

  // W widoku specyfikacji usługi skojażóne z oponą
  public Services: string

  // W widoku specyfikacji wskazuje czy opona jest wykorzysytwana w danej usludze
  public IsUsed: boolean;

  public IsAvailable: boolean;

  // W widoku specyfikacji wskazuje czy opona zostanie zutylizowana z racji na za niski bieznik
  public IsTooShortHeightTread: boolean;
}
